import type { DomApplier } from '../cssFeatures.types'

export const pageTransitionsDomApplier: DomApplier<'pageTransitions'> = (
	__,
	___,
	____,
	{ pageTransitionsViewTransition }
) => {
	if (!pageTransitionsViewTransition) {
		return null
	}

	// Generate @view-transition rule with the specific transition type
	return {
		'@view-transition': {
			navigation: 'auto',
			types: pageTransitionsViewTransition.transitionName,
		},
	}
}
